import router from '@/router/router'
import store from '@/store/store'
import BootstrapVue from 'bootstrap-vue'
import PortalVue from 'portal-vue'
import money from 'v-money'
import VeeValidate from 'vee-validate'
import ptBR from 'vee-validate/dist/locale/pt_BR'
import Vue from 'vue'
import BackToTop from 'vue-backtotop'
import VueApexCharts from 'vue-apexcharts'

import VueI18n from 'vue-i18n'
import VueLoading from 'vue-loading-overlay'
import Multiselect from 'vue-multiselect'
import VueQuillEditor from 'vue-quill-editor'
import VueSuggestion from 'vue-suggestion'
import VueTheMask from 'vue-the-mask'
import VueUploadComponent from 'vue-upload-component'
import App from './App.vue'
import './filters/global'
import api from './util/api'

import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

Vue.use(VueTheMask)
Vue.use(PortalVue)
Vue.use(money)
Vue.use(VueApexCharts)

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'ptBR'
})

Vue.use(VeeValidate, {
  fieldsBagName: 'veeFields',
  i18n,
  dictionary: {
    ptBR
  },
  validity: true
})

Vue.use(BootstrapVue)
Vue.use(BackToTop)
Vue.use(VueQuillEditor)
Vue.use(VueSuggestion)
Vue.use(api)

Vue.config.productionTip = false
Vue.config.devtools = true

Vue.component('multiselect', Multiselect)
Vue.component('file-upload', VueUploadComponent)
Vue.component('loading', VueLoading)
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
